import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';

// Utility to compare rooms arrays without touching non-serializable refs
export const areRoomsEqual = (
  a?: ListingSearchRoomInterface[] | null,
  b?: ListingSearchRoomInterface[] | null
): boolean => {
  const arrA = a || [];
  const arrB = b || [];
  if (arrA.length !== arrB.length) return false;
  for (let i = 0; i < arrA.length; i++) {
    const ra = arrA[i];
    const rb = arrB[i];
    if (!ra || !rb) return false;
    if (ra.adultCount !== rb.adultCount) return false;
    const childrenA = ra.childrenList || [];
    const childrenB = rb.childrenList || [];
    if (childrenA.length !== childrenB.length) return false;
    for (let j = 0; j < childrenA.length; j++) {
      const ca = childrenA[j];
      const cb = childrenB[j];
      if (!ca || !cb) return false;
      if (String(ca.age || '') !== String(cb.age || '')) return false;
    }
  }
  return true;
};

export default areRoomsEqual;
